import { popupStore } from '@pascal/pascal-core';
import { gameLiveConnection } from '../services';

class LiveConnection {
  isConnected = false;

  handleSocketInit() {
    gameLiveConnection
      ?.init()
      .then(() => {
        this.isConnected = true;
        this.connectionInitCallback();
      })
      .catch(() => popupStore.onConnectionError(true));
  }

  restartGameConnection() {
    return new Promise((res) => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          this.connectionInitCallback();
          res();
        });
      });
    });
  }

  connectionInitCallback(isFirstInit) {
    if (this.isConnected) {
      gameLiveConnection.sendGameGetInitialState(isFirstInit).then(() => {});
    }
  }
}

export const liveConnection = new LiveConnection();
